module.exports = __webpack_public_path__ + "stylesheets/icon-text-list_a167dd2ab3f261b73dd66e91e2956075.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/icon-text-list.less
// module id = 5G1g
// module chunks = 153